import { createContext } from "@pharaday/utils";
import type { VariantProps } from "class-variance-authority";

import type { alertRootStyle } from "./styles";

export type AlertRootContext = VariantProps<typeof alertRootStyle>;

const [useAlertRootContext, AlertRootContextProvider] = createContext<AlertRootContext>();

export { AlertRootContextProvider, useAlertRootContext };
